import { render } from "./StructureField.vue?vue&type=template&id=474987d4"
import script from "./StructureField.vue?vue&type=script&lang=js"
export * from "./StructureField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__